module.exports = __webpack_public_path__ + "static/media/2_r_ceburashka_83.49_79.44.70e09ed9.png";